import React from 'react'
import Layout from '../components/UnifyLayout'
import Promo from '../components/Promo'
import TextVideoCTA from '../components/TextVideoCTA'
import NewsletterSignup from '../components/NewsletterSignup'
import ThreeCardGrid from '../components/ThreeCardGrid'
import ThreeTableGrid from '../components/ThreeTableGrid'
import Counters from '../components/Counters'
import IconBlocks from '../components/IconBlocks'
import LatestNews from '../components/LatestNews'
import SEO from '../components/SEO'
import Container from '../components/Container'
import PageTitle from '../components/PageTitle'
import ContactForm from '../components/ContactForm'

const Index = ({ pageContext, data }) => {
  return (
    <Layout>
      {console.log(data)}
      <Promo />
      <IconBlocks />
      <hr className="g-brd-gray-light-v4 my-0" />
      <LatestNews context={pageContext} posts={data.allContentfulPost.edges} />
      <NewsletterSignup data={data} />
    </Layout>
  )
}

export const query = graphql`
  query {
    allContentfulPost(
      sort: { fields: [publishDate], order: DESC }
      limit: 3
    ) {
      edges {
        node {
          title
          id
          slug
          publishDate(formatString: "MMMM DD, YYYY")
          heroImage {
            title
            fluid(maxWidth: 1800) {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
            ogimg: resize(width: 1800) {
              src
            }
          }
          body {
            childMarkdownRemark {
              timeToRead
              html
              excerpt(pruneLength: 80)
            }
          }
        }
      }
    }
  }
`

export default Index